/* eslint-disable @typescript-eslint/no-explicit-any */
export const environment = {
  buildShortSha: 'db9ba92', // Replaced during build - passed from the CI into the build process
  environmentName: ((window as any).__env?.ENVIRONMENT_NAME as string) || '',
};
